// src/components/WhyChooseUs.js
import React, { useState } from 'react';
import styles from '../App.module.css';

const WhyChooseUs = () => {
  const [loading, setLoading] = useState(false)
  return (
    <>
    {
      loading ? (
        <div role="status" className="space-y-8 animate-pulse md:space-y-0 md:space-x-8 rtl:space-x-reverse md:flex md:items-center">
          <div className="flex items-center justify-center w-full h-96 bg-slate-500 dark:bg-gray-700">
            <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
              <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
            </svg>
          </div>
        </div>
      ):(        
        <section id="why-choose-us" className="bg-dark text-white" data-aos="fade-up">
          <div className="container-fluid">
            <div className="row p-0">
              <div className="col-md-12 p-0 position-relative">
                <h2 className={`text-6xl font-bold mb-0 text-yellow-400 uppercase position-absolute ${styles.heading_alignment}`}>Why You Should<br/> Choose Us?</h2>
                <img loading="lazy" src='./images/why_choose_section_bg.png' alt="Why Choose Us" />
                <a href="javascript:void(0)" className={`position-absolute ${styles.play_icon}`}>              
                  <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" fill="currentColor" className={`bi bi-play-circle text-yellow-400`} viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                    <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </section>
      )
    }
    </>
  );
}

export default WhyChooseUs;
